export const SET_SEND_DATA = 'SET_SEND_DATA';
export const RESET_SEND_DATA = 'RESET_SEND_DATA';
export const SET_SECONDRY_DATA = 'SET_SECONDRY_DATA';
export const RESET_SECONDRY_DATA = 'RESET_SECONDRY_DATA';
